import PaymentMethodEdit from './PaymentMethodEdit';

export default PaymentMethodEdit;


// WEBPACK FOOTER //
// ./resources/assets/js/components/PaymentMethodEdit/index.js